import { createGlobalStyle } from 'styled-components';

const globalClasses = `
  .prevent-body-scroll {
    overflow-y: hidden;
  }
`;
export default globalClasses;
export const GlobalClasses = createGlobalStyle`
  ${globalClasses}
`;
